module.exports = __webpack_public_path__ + "static/media/hero-laptop.4d1028a3.svg";